module.exports = __webpack_public_path__ + "img/charging_and_starting_system.a168c1a3.svg";